import Transform from './Base';

export default class BrandingTransform extends Transform {
  /**
   * Method used to transform a fetched branding.
   *
   * @param data The fetched branding.
   *
   * @returns {Object} The transformed branding.
   */
  static fetch(data) {
    return {
      theme: data.color_scheme,
      service_name: data.service_name,
      logo_url: data.logo_url,
      home_url: data.home_url,
      knoweledge_base_url: data.knoweledge_base_url,
      eula_url: data.eula_url,
      buy_url: data.buy_url,
      support_url: data.support_url,
      support_phone: data.support_phone,
    };
  }
}
